import 'antd/dist/antd.css';
import React from 'react';
import styles from './index.module.less'
import { Button, Col, Form, Input, Radio, Row, Space, Tooltip, Modal, Spin } from 'antd'
import useBaseRequest from '@/hooks/useBaseRequest'
import { checkUserAttribute, submitdata, getCodeFromUcpImpl, resetNewPasswordRecoveryApply, getValidate, passwordLevel } from '@/api'
import CustomPhone from '@/components/CustomPhone'
import useTimer from '@/hooks/useTimer' // 引入Hook
import { useEffect, useState } from 'react'
// import { StyleProvider } from '@ant-design/cssinjs';
import IdentifyingCode from './identifyingCode'
import useDebounce from '@/hooks/useDebounce'
import { ExclamationCircleOutlined } from '@ant-design/icons'

import { yellow, red, green } from '@ant-design/colors';
import tipspng from '@/assets/tips.png'

import './index.css'

const layoutcal = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 18,
  }
}

function padStart(str) {
  if (str) {

    return str?.length >= 10 ? str : new Array(10 - str.length + 1).join('0') + str;
  } else {
    return undefined
  }
}
function encodeFormData(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
}


function isSmallScreen(label) {
  if (window.innerWidth <= 575) {
    return label + '::'
  }
  return label
}
var timer = null;

export default function Index() {
  const [form] = Form.useForm()
  const watchloginName = Form.useWatch('loginName', form)
  const watchwayback = Form.useWatch('wayback', form)

  const watchname = Form.useWatch('name', form)
  const watchidCard = Form.useWatch('idCard', form)
  const watchphone = Form.useWatch('phone', form)
  const [showtime, setShowtime] = useState(false) //显示倒计时
  const [showtpsw, setShowpsw] = useState('') //显示密码框 key
  const [tips, settips] = useState('请输入账号')
  const { count, start } = useTimer(60, () => { setShowtime(false) })

  const watchpsw = Form.useWatch('newPassword', form)
  const [pswlevel, setPswlevel] = useState()

  const [open, setOpen] = useState(false)
  const [iframeLoaded, setIframeLoaded] = useState(false); // Track iframe loading state

  // Preload iframe content in background
  useEffect(() => {
    // Create iframe element off-screen to preload content
    // const iframe = document.createElement('iframe');
    // iframe.src = 'https://apps.shutcm.edu.cn/#/share/eyJhcHBOYW1lIjoicHJvLm1vYmlsZSIsInNoYXJlU2lnbmF0dXJlIjoiODlCNjExRjE0RDBFQzZBNUU0OTA1MzVBNDhGQUVCOEUifQ%3D%3D';
    // iframe.style.display = 'none';  // Hide iframe while loading
    // iframe.onload = () => setIframeLoaded(true);  // Set iframe as loaded once content is ready
    // document.body.appendChild(iframe);  // Add the iframe to the document to start loading
  }, []);
  const delayedQuery = useDebounce((q) => _passwordLevelrun(q), 500)
  const { run: _passwordLevelrun } = useBaseRequest(passwordLevel, {
    manual: true,
    onSuccess: (result, params) => {
      if (result && result.data) {
        setPswlevel(result.data?.level)

      } else {
        console.log(result)
      }
    },
  });
  const [validateWay, setValidateWay] = useState({
    hasPhone: false,
    hasEmail: false
  })
  const { run: getValidateRun } = useBaseRequest(getValidate, {
    // refreshDeps:[watchloginName],
    manual: true,
    onSuccess: (res) => {
      console.log(res, 'res');
      if (res.data?.resultCode == "0") {
        settips('')
        setValidateWay(res?.data?.result?.data || {
          hasPhone: true,
          hasEmail: false
        })
      }
      else {
        settips(res?.data?.errorMsg || '')
        // message.warn(res?.data?.errorMsg)
        form.setFieldValue('wayback', undefined)
        setValidateWay({
          hasPhone: false,
          hasEmail: false
        })
      }
    }
  })


  const { loading, run } = useBaseRequest(checkUserAttribute, {
    manual: true,
    onSuccess: (result, params) => {
      if (result.data === "success") {
        getCodeFromUcpImplrun()
      } else {
        error({
          title: '提示',
          content: result.data,
        });
      }
    },
  });
  const { loading: getCodeFromUcpImplloading, run: getCodeFromUcpImplrun } = useBaseRequest(getCodeFromUcpImpl, {
    manual: true,
    onSuccess: (result, params) => {
      if (result.data === "success") {
        setShowtime('true')
        start()
      } else {
        error({
          title: '提示',
          content: result.data,
        });
      }
    },
  });


  const { loading: submitdataloading, run: submitdatarun } = useBaseRequest(submitdata, {
    manual: true,
    onSuccess: (result, params) => {
      var res = result.data.split("|");
      if (res[0] === 'success') {
        res[1] && setShowpsw(res[1])
      } else {
        error({
          title: '提示',
          content: result.data,
        });
      }
    },
  });

  const { loading: resetNewPasswordRecoveryApplyloading, run: resetNewPasswordRecoveryApplyrun } = useBaseRequest(resetNewPasswordRecoveryApply, {
    manual: true,
    onSuccess: (result, params) => {
      var res = result.data.split(",");
      if (res[0] === 'success') {
        Modal.success({
          title: '提示', content: res[1], okText: '确定', onOk: () => {
            window.location = 'http://ehall.shutcm.edu.cn'
          }
        });
      } else {
        error({
          title: '提示',
          content: result.data,
        });
      }
    },
  });

  const error = ({ title, content }) => {
    if (content?.includes('手机号与系统中不一致')) {
      Modal.error({ title, content:'输入手机号和预留手机号不符', okText: '确定' });

      // Modal.confirm({
      //   title, content: <div>
      //     输入手机号与系统中预留手机号不一致！是否需修改手机号？
      //     <span style={{ color: '#a41f34' }}>（当前仅支持连接校园网环境访问修改）</span>
      //   </div>, okText: '否，重新输入', okButtonProps: {
      //     size: 'small',
      //     style: {
      //       marginTop: window.innerWidth <= 329 ? '12px' : '0'
      //     }
      //   }, cancelButtonProps: {
      //     size: 'small',
      //   }, cancelText: '是，修改预留手机号', onOk() {
      //     form.setFieldValue('phone', '')
      //     console.log('OK');
      //   },
      //   onCancel() {
      //     console.log('Cancel');
      //     setOpen(true)
      //     // window.open('https://apps.shutcm.edu.cn/#/share/eyJhcHBOYW1lIjoicHJvLm1vYmlsZSIsInNoYXJlU2lnbmF0dXJlIjoiODlCNjExRjE0RDBFQzZBNUU0OTA1MzVBNDhGQUVCOEUifQ%3D%3D')
      //   },
      // });
    } else {
      Modal.error({ title, content, okText: '确定' });
    }

  };
  const getPhoneValidateCode = () => {
    if (!watchloginName) {
      error({
        title: '提示',
        content: '请输入账号',
      });
      return
    }
    if (!watchname) {
      error({
        title: '提示',
        content: '请输入姓名',
      });
      return
    }
    if (!watchphone) {
      error({
        title: '提示',
        content: '请输入手机号',
      });
      return
    }
    if (!watchidCard) {
      error({
        title: '提示',
        content: '请输入证件号',
      });
      return
    }
    run({ domainId: '1', phone: watchphone, loginName: padStart(watchloginName), name: watchname, idCard: watchidCard })
  }


  const SubmitForm = (value) => {
    console.log(value)
    const formData = encodeFormData({ ...value, loginName: padStart(value.loginName) })
    submitdatarun(formData)
  }
  const SubmitFormpsw = (value) => {
    if (pswlevel <= 1) {
      Modal.warn({
        title: '提示', content: '您设置的密码不符合密码强度要求，请避免连续性数字或简单字符', okText: '确定', onOk: () => {
          // window.location = 'http://ehall.shutcm.edu.cn'
        }
      });
    } else {
      const formData = encodeFormData({ ...value })
      resetNewPasswordRecoveryApplyrun({
        data: formData,
        params: {
          domainId: '1',
          key: showtpsw
        }
      })
    }


  }
  function debounce(delay) {
    if (timer) {
      console.log(333);
      //如果有这个定时器就直接清除掉 不然再执行
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      // message.warn(res?.data?.errorMsg)
      form.setFieldValue('wayback', undefined)
      setValidateWay({
        hasPhone: false,
        hasEmail: false
      })
      getValidateRun({
        loginName: padStart(watchloginName)
      })
    }, delay);
  };


  useEffect(() => {
    console.log((!validateWay?.phone) && validateWay?.email, 'validateWay');
   watchloginName&& debounce(800)
  }, [watchloginName])
  useEffect(() => {
    if (!watchpsw) {
      return
    }
    const formData = encodeFormData({ password: watchpsw })
    delayedQuery(formData)

  }, [watchpsw])
  useEffect(() => {
    const handlePostMessage = (event) => {
      // Ensure the message is coming from a trusted source

      // Example: Close the modal if the iframe sends 'close' message
      if (event.data === 'closeLayerPerson') {
        setOpen(false);
      }

    };

    // Add event listener
    window.addEventListener('message', handlePostMessage);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('message', handlePostMessage);
    };
  }, []);
  useEffect(() => {
    if (pswlevel || pswlevel === 0) {
      // 如果密码强度弱，则手动触发校验
      form.validateFields(['newPassword']).then(() => {

      });
    }
    // height: 'calc(100vh + 80px)', marginTop: 20,
  }, [pswlevel, form]);
  const IframeCom = () => <iframe style={{ width: '100%', height: "100%", border: 'none' }} src='https://apps.shutcm.edu.cn/#/share/eyJhcHBOYW1lIjoicHJvLm1vYmlsZSIsInNoYXJlU2lnbmF0dXJlIjoiODlCNjExRjE0RDBFQzZBNUU0OTA1MzVBNDhGQUVCOEUifQ%3D%3D' />
  return (
    // <StyleProvider hashPriority="high">
    <div className={styles.box}>
      <div className={styles.head}></div>
      <div className={styles.container}>
        <div className={styles.passback}>
          <div className={styles.backtitle}>{showtpsw ? '设置新密码' : '统一认证密码重置'}</div>
          <div className={styles['passback-con']}>
            {
              showtpsw ?
                <Form
                  {...layoutcal}
                  form={form}
                  // labelCol={{
                  //   span: 5,
                  // }}
                  layout="horizontal"
                  onFinish={SubmitFormpsw}
                >
                  {/* {
                    pattern: /^[\x20-\x7E]+$/, // 只允许半角字符
                    message: '请输入英文字符',
                  }, */}
                  <Form.Item label={isSmallScreen('新密码')} name='newPassword' rules={[{ required: true, message: '请输入密码!' }, ({ getFieldValue }) => ({
                    validator(_, value) {
                      console.log(pswlevel, 'pswlevel');

                      if (pswlevel === 0 || pswlevel === 1) {
                        return Promise.reject((<div>你的密码为弱密码，请重新设置！ <Tooltip title={<div style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
                          <div>1.请避免使用连续或相同的英文、数字，如123456、abcdefg等；</div>
                          <div>2.请避免使用个人信息，如姓名、出生日期、常用单词等；</div>
                        </div>} color={'#fff'}  >
                          <img src={tipspng} style={{ width: '24px' }} />
                          {/* <ExclamationCircleOutlined /> */}
                        </Tooltip></div>));
                      }
                      return Promise.resolve();
                    },
                  })]}>
                    <Input.Password placeholder='请输入新密码' />
                  </Form.Item>
                  <Form.Item label={isSmallScreen('确认密码')} name='rePassword' rules={[{ required: true, message: '请输入密码!' }, ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('newPassword') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('密码不一致!'));

                    },
                  }),]}>
                    <Input.Password placeholder='请再次输入新密码' />
                  </Form.Item>
                  {/* <div>
                    <p className={styles.remark}>
                      密码强度：
                      <Progress
                        style={{ marginLeft: '16px' }}
                        percent={(() => {
                          if (pswlevel === 0) return 100/3/2; // 显示第一个格子的一半 (100% ÷ 3 ÷ 2)
                          if(pswlevel===3) return 100/3*2+100/3/2
                          return ((Math.min(pswlevel, 4) + 1) / 5) * 100; // 其余情况按比例分配
                        })()}
                        showInfo={false}
                        steps={3} // 将进度条分为3步
                        strokeColor={[
                          yellow[5], // 第一个格子颜色 (非常弱/弱)
                          green[5],  // 第二个格子颜色 (中等)
                          red[5],    // 第三个格子颜色 (强/非常强)
                        ]}
                      />
                      {pswlevel !== undefined ? (
                        <span style={{ marginLeft: '12px' }}>
                          {['非常弱', '弱', '中等', '强', '非常强'][pswlevel]}
                        </span>
                      ) : (
                        ''
                      )}
                    </p>
                   

                    <span className={styles.remark}>密码规则：
                      密码必须包含字母、数字、特殊字符 且密码长度必须为8-20位！</span>
                  </div> */}

                  <div>
                    <p className={styles.remark}>
                      密码强度：
                      <div style={{ display: 'inline-block', alignItems: 'center', marginLeft: '16px' }}>
                        {/* 自定义进度条 */}
                        <div className={styles.progressSelf}
                        >
                          {/* 第一格 */}
                          <div className={styles.progressSelfItem}>
                            <div
                              style={{
                                height: '100%',
                                backgroundColor: yellow[5],
                                // backgroundColor: pswlevel === 0 || pswlevel >= 1 ? yellow[5] : '#f3f3f3', // 黄色或灰色
                                width: pswlevel === 0 ? '50%' : pswlevel >= 1 ? '100%' : '0%',
                                transition: 'width 0.3s',

                              }}
                            />
                          </div>
                          {/* 第二格 */}
                          <div className={styles.progressSelfItem}>
                            <div
                              style={{
                                height: '100%',
                                backgroundColor: green[5],
                                width: pswlevel === 2 ? '100%' : pswlevel > 2 ? '100%' : '0%',
                                transition: 'width 0.3s',
                              }}
                            />
                          </div>
                          {/* 第三格 */}
                          <div className={styles.progressSelfItem}>
                            <div
                              style={{
                                height: '100%',
                                backgroundColor: red[5],
                                // backgroundColor: pswlevel === 0 || pswlevel >= 1 ? red[5] : '#f3f3f3', // 黄色或灰色
                                width: pswlevel >= 3 ? (pswlevel === 3 ? '50%' : '100%') : '0%',
                                transition: 'width 0.3s',
                              }}
                            />
                          </div>
                        </div>

                      </div>
                      {/* 密码强度标签 */}
                      {pswlevel !== undefined && (
                        <span style={{ marginLeft: '12px' }}>
                          {['非常弱', '弱', '中等', '强', '非常强'][pswlevel]}
                        </span>
                      )}
                    </p>

                    <span className={styles.remark}>
                      密码规则：密码必须包含字母、数字、特殊字符 且密码长度必须为 8-20 位！
                    </span>
                  </div>

                  <div className={styles.btns}>
                    <Button style={{ width: '100%' }} className={styles.btn} htmlType='submit'>确定</Button>
                  </div>
                </Form>
                :
                <Form
                  className='checkform'
                  {...layoutcal}
                  form={form} initialValues={{
                    // wayback: 'phone'
                  }}
                  layout="horizontal"
                  onFinish={SubmitForm}
                >
                  <Form.Item label={isSmallScreen('账号')} name='loginName' rules={[{ required: true, message: '请输入账号!' }]}>
                    <Input placeholder='请输入学工号' />
                  </Form.Item>
                  <Form.Item label={isSmallScreen('姓名')} name='name' rules={[{ required: true, message: '请输入姓名!' }]}>
                    <Input placeholder='请输入姓名' on />
                  </Form.Item>
                  <Form.Item label={isSmallScreen('证件号')} name='idCard' rules={[{ required: true, message: '请输入证件号!' }
                    // , {
                    //   pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '证件号不合法'
                    // }
                  ]}>
                    <Input placeholder='请输入身份证、护照号等证件号' />
                  </Form.Item>
                  <Form.Item label='找回方式' name='wayback' rules={[{ required: true, message: '请选择找回方式!' }]} style={{ marginBottom: !validateWay?.hasPhone && !validateWay?.hasEmail ? '0px' : 'revert-layer' }}>
                    <Radio.Group>
                      <Radio value='phone' disabled={!validateWay?.hasPhone}>手机号</Radio>
                      <Radio value='email' disabled={!validateWay?.hasEmail}>邮箱</Radio>
                    </Radio.Group>
                  </Form.Item>
                  {/* {
                  (!validateWay?.hasPhone||!validateWay?.hasEmail)&&<Form.Item label={" "}  colon={false} style={{color:'#a09d9d'}}>
                 {
                 tips|| <>找回方式不可用，请先维护{!validateWay?.hasPhone?'手机号':''}{!validateWay?.hasPhone&&!validateWay?.hasEmail?'或':''}{!validateWay?.hasEmail?'邮箱':''}。   </>
                 }  
                  </Form.Item>
                } */}
                  {
                    (tips || (!validateWay?.hasPhone && !validateWay?.hasEmail)) && <Form.Item label={" "} colon={false} style={{ color: '#a09d9d' }}>
                      {
                        tips || <>找回方式不可用，请先维护手机号或邮箱。 </>
                      }
                    </Form.Item>
                  }
                  {
                    watchwayback == 'phone' && <><Form.Item label={isSmallScreen('手机号')} name='phone' rules={[{ required: true, message: '请输入手机号!' }, {
                      pattern: /^1[3-9]\d{9}$/, message: '手机号不合法'
                    }]}>
                      <CustomPhone callback={getPhoneValidateCode} count={count} showtime={showtime} />
                    </Form.Item> <Form.Item label={isSmallScreen('验证码')} name='phoneValidateCode' rules={[{ required: true, message: '请输入验证码!' }]}>
                        <Input placeholder='请输入短信验证码' />
                      </Form.Item></>
                  }
                  {
                    watchwayback == 'email' && <>
                      <Form.Item label={isSmallScreen('邮箱号')} name='email' rules={[{ required: true, message: '请输入邮箱号!' }]}>
                        <Input placeholder='请输入邮箱号' />
                      </Form.Item> <Form.Item
                        label="验证码"
                        name="emailValidateCode"
                        rules={[
                          {
                            required: true,
                            message: "请输入验证码",
                          },
                        ]}
                      >
                        <IdentifyingCode isvalidatecode={true} />
                      </Form.Item> </>
                  }




                  <div>
                    <span className={styles.remark}>注：统一认证账号用于学校上网认证、VPN、一网通办平台等软件系统。</span>
                  </div>
                  <div className={styles.btns}>
                    <Row>
                      <Col span={12}> <Button className={styles.btn} htmlType='submit'>确定</Button></Col>
                      <Col span={12}> <Button style={{ backgroundColor: '#9d9b9b' }} className={styles.btn}>取消</Button></Col>
                    </Row>
                  </div>
                </Form>
            }
          </div>
        </div>
      </div>
      <div className={styles.foot}>
        <p>Copyright @ 2018 上海中医药大学版权所有 <br /> 地址：上海市蔡伦路1200号 沪ICP备09008682号</p>
      </div>
      {/* <div style={{ display: 'none' }}>
        <IframeCom />
      </div> */}
      <Modal open={open} onCancel={() => setOpen(false)} footer={null} width='733px' className='iframModal'>
        {/* <Spin spinning={!iframeLoaded}> */}
        <div style={{ height: '472px' }} className='IframeComDiv'>
          <IframeCom />
        </div>
        {/* </Spin> */}
      </Modal>
    </div>
    // </StyleProvider>
  )
}